import React from 'react';
import {URLS} from "@/lib/urls";
import {MasterLayout} from "@/components/layout/masetr/master";


function StudentLayout({pageTitle, children, breadCrumb, backTo, pageLoading = false}) {


    const menu = [
        {name: 'داشبورد', path: URLS.student.dashboard, icon: "icon-grid-2"},
        {name: 'درس‌های من', path: URLS.student.lessons.myLesson.list, icon: "icon-book-heart"},
        {name: 'پروفایل', path: URLS.student.profile.dashboard, icon: "icon-user"},
        {name: 'مالی', path: URLS.student.billing.dashboard, icon: "icon-money-bill-wave"},
        {name: 'بازگشت وجه', path: URLS.student.billing.refund, icon: "icon-money-bill"},
        {name: 'اقساط', path: URLS.student.installments.dashboard, icon: "icon-money-bill-wave"},
        {name: 'گواهی‌نامه‌ها', path: URLS.student.certifications.dashboard, icon: "icon-certificate"},
        {name: 'انتخاب درس', path: URLS.student.lessons.take, icon: "icon-book-medical"},
        {name: 'آموزش مجازی', path: URLS.lms.dashboard, icon: "icon-book-sparkles"},
        {name: 'نمره', path: URLS.student.scores.dashboard, icon: "icon-badge"},
        {name: 'غیبت‌ها', path: URLS.student.absences.dashboard, icon: "icon-user-xmark"},
        {name: 'نظرسنجی‌ها', path: URLS.student.survey.publicSurvey, icon: "icon-chart-column"},

    ]


    return (
        <MasterLayout module={'student'}
                      pageTitle={pageTitle}
                      breadCrumb={breadCrumb}
                      sidebarMenu={menu}
                      backTo={backTo}
                      pageLoading={pageLoading}
        >
            {children}
        </MasterLayout>
    );
}

export default StudentLayout;